import {
    Box,
    Card,
    Chip,
    Divider,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
import Date from "../../../../../utils/date";
import { CertificadoNCotroladoPdf } from "./certificado/autorizacaoImportacaoNcontrolado";
import { CertificadoInternacionamento } from "./certificado/certificadoInternacionamento";
import { CertificadoMedicamento } from "./certificado/certificadoMedicamento";
import { CertificadoEquipamentos } from "./certificado/certificadoEquipamentos";
import { DesalfandegamentoDeclaracaoExcepcional } from "./desalfandegamentoNovos/desalfandegamentoDeclaracaoExcepcional";
import { DesalfandegamentoDeclaracaoExclusividade } from "./desalfandegamentoNovos/desalfandegamentoDeclaracaoExclusividade";
import { DesalfandegamentoDeclaracao } from "./desalfandegamentoNovos/desalfandegamentoDeclaracao";

export default function DocumentosEmitidos({ solicitacaoImportacao }) {
    const handleCertificado = (solicitacaoImportacao, certificado) => {
        const categoriasInternacionamento = ["Estupefaciente", "Percursores", "Psicotrópico"];

        if (
            certificado?.tipoCertificado === "Medicamento" &&
            categoriasInternacionamento.includes(certificado?.productoRefente?.categoria)
        ) {
            CertificadoInternacionamento(solicitacaoImportacao, certificado);
        } else if (certificado?.tipoCertificado === "Equipamento") {
            CertificadoEquipamentos(solicitacaoImportacao, certificado);
        } else if (certificado?.tipoCertificado === "Medicamento") {
            CertificadoMedicamento(solicitacaoImportacao, certificado);
        }
    };

    const certificados = Array.isArray(solicitacaoImportacao?.certificado)
        ? solicitacaoImportacao.certificado
        : [];

    // LOGICA PARA VERIFICAR SE EXISTE DECLARAÇÃO OU DECLARAÇÃO DE EXCLUSIVIDADE
    const temDeclaracao = Boolean(solicitacaoImportacao?.declaracao?.dataAprovacao);
    // const temDeclaracaoExcepcional = temDeclaracao;

    // const temExclusividade = Boolean(
    //     solicitacaoImportacao?.declaracaoExclusividade ||
    //     solicitacaoImportacao?.declaracao?.declaracaoExclusividade ||
    //     solicitacaoImportacao?.declaracao?.exclusividade
    // );

    // FUNÇÃO PARA RENDERIZAR CADA ITEM DE EXPORTAÇÃO (CERTIFICADO OU DECLARAÇÃO)
    const renderExportItem = ({
        key,
        label,
        subtitle,
        onDownload,
        tipo = "Documento",
        data,
    }) => (
        <Box
            key={key}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                py: 1.5,
                px: 1.5,
                borderRadius: 2,
                border: "1px solid #EAEAF4",
                background: "linear-gradient(180deg, #FFFFFF 0%, #F8FAFF 100%)",
            }}
        >
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0, flex: 1 }}>
                <IconButton
                    color="secondary"
                    onClick={onDownload}
                    sx={{
                        backgroundColor: "#EEF2FF",
                        border: "1px solid #DDE6FF",
                        width: 42,
                        height: 42,
                        "&:hover": { backgroundColor: "#E3EAFE" },
                    }}
                >
                    <DownloadOutlinedIcon fontSize="small" />
                </IconButton>

                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5, flexWrap: "wrap" }}>
                        <Chip
                            label={tipo}
                            size="small"
                            color="secondary"
                            variant="outlined"
                            sx={{ fontWeight: 700, borderRadius: 1 }}
                        />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#1F2937" }}>
                            {label}
                        </Typography>
                    </Stack>

                    {data ? (
                        <Typography variant="caption" sx={{ color: "#4B5563" }}>
                            <Date date={data} />
                        </Typography>
                    ) : (
                        <Typography variant="caption" sx={{ color: "#6B7280" }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Stack>

            <ArticleOutlinedIcon sx={{ color: "#7C3AED", opacity: 0.8 }} />
        </Box>
    );

    return (
        solicitacaoImportacao && (
            <Card sx={{ p: 2, borderRadius: 3, boxShadow: "0 8px 22px rgba(15, 23, 42, 0.06)" }}>

                {/* CERTIFICADOS EMITIDOS PARA NÃO CONTROLADOS */}
                {solicitacaoImportacao?.solicitacaoArea === "Não Controlados" && certificados.length > 0 && (
                    <>
                        <HeaderGestorConfigs title={"CERTIFICADOS EMITIDOS"} />
                        {renderExportItem({
                            key: "autorizacao-importacao-nao-controlados",
                            label: "Autorização de importação - não controlados",
                            subtitle: "Documento de autorização emitido",
                            tipo: "Certificado",
                            data: solicitacaoImportacao?.certificado[0]?.dataEmissao,
                            onDownload: () =>
                                CertificadoNCotroladoPdf(
                                    solicitacaoImportacao,
                                    solicitacaoImportacao?.certificado
                                ),
                        })}
                    </>
                )}

                {/* CERTIFICADOS EMITIDOS PARA CONTROLADOS */}
                {solicitacaoImportacao?.solicitacaoArea !== "Não Controlados" && certificados.length > 0 && (
                    <>
                        <HeaderGestorConfigs title={"CERTIFICADOS EMITIDOS"} />
                        <Stack spacing={1.5} sx={{ mt: 1 }}>
                            {certificados.map((certificado, index) => {
                                const label = `Certificado de controlado - ${certificado?.productoRefente?.nome || "Produto"} - ${certificado?.numeroCertificado || "N/A"}`;

                                return renderExportItem({
                                    key: `certificado-${certificado?._id || index}`,
                                    label,
                                    subtitle: "Certificado emitido para importação",
                                    tipo: "Certificado",
                                    data: certificado?.dataEmissao,
                                    onDownload: () => handleCertificado(solicitacaoImportacao, certificado),
                                });
                            })}
                        </Stack>
                    </>
                )}

                {/* DECLARAÇÕES EMITIDAS */}
                {/* {(temDeclaracao || temExclusividade) && ( */}
                {(temDeclaracao) && (
                    <>
                        <Divider sx={{ my: 2.5 }} />
                        <HeaderGestorConfigs title={"DECLARAÇÕES "} />  {/* EMITIDAS */}
                        <Stack spacing={1.5} sx={{ mt: 1 }}>
                            {
                                // DECLARAÇÃO DE DESALFANDEGAMENTO
                                // temDeclaracao && (
                                renderExportItem({
                                    key: "declaracao-desalfandegamento",
                                    label: `Declaração de desalfandegamento - ${solicitacaoImportacao?.declaracao?.numeroDeclaracao || "N/A"}`,
                                    subtitle: "Documento emitido para desalfandegamento",
                                    tipo: "Declaração",
                                    data: solicitacaoImportacao?.declaracao?.dataEmissao,
                                    onDownload: () => DesalfandegamentoDeclaracao(solicitacaoImportacao),
                                })
                                // )
                            }

                            {
                                // DECLARAÇÃO DE DESALFANDEGAMENTO EXCEPCIONAL
                                // temDeclaracaoExcepcional && (
                                renderExportItem({
                                    key: "declaracao-desalfandegamento-excepcional",
                                    label: `Declaração de desalfandegamento excepcional - ${solicitacaoImportacao?.declaracao?.numeroDeclaracao || "N/A"}`,
                                    subtitle: "Documento de autorização excepcional",
                                    tipo: "Declaração",
                                    data: solicitacaoImportacao?.declaracao?.dataEmissao,
                                    onDownload: () => DesalfandegamentoDeclaracaoExcepcional(solicitacaoImportacao),
                                })
                                // )
                            }

                            {
                                // DECLARAÇÃO DE EXCLUSIVIDADE
                                // temExclusividade && (
                                renderExportItem({
                                    key: "declaracao-exclusividade",
                                    label: "Declaração de exclusividade",
                                    subtitle: "Documento complementar para a declaração",
                                    tipo: "Declaração",
                                    data: solicitacaoImportacao?.declaracao?.dataEmissao || solicitacaoImportacao?.declaracaoExclusividade?.dataEmissao,
                                    onDownload: () => DesalfandegamentoDeclaracaoExclusividade(solicitacaoImportacao),
                                })
                                // )
                            }
                        </Stack>
                    </>
                )}
            </Card>
        )
    );
}
